import React, { memo, useEffect, useRef } from 'react';

import 'pannellum/build/pannellum.css';
import 'pannellum';
import ErrorBoundary from '../GeneralForm/ErrorBoundary';
import CustomModal from '../GeneralForm/CustomModal';

const PanoramaViewer = ({ id, sceneId, imageSource, config }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    const pannellum = window.pannellum;

    if (container && pannellum && Object.keys(pannellum).length > 0) {
      const viewer = pannellum?.viewer(container, {
        type: 'equirectangular',
        panorama: imageSource,
        sceneId: sceneId,
        ...config
      });

      return () => {
        viewer.destroy();
      };
    }
  }, [id, sceneId, imageSource, config]);

  return (
    <div
      ref={containerRef}
      id={id}
      style={{ height: '75vh', background: '#121212', border: '1px solid #222222' }}
    />
  );
};

const Insta360ViewerModal = ({ isOpen, toggle, data }) => {
  const [state, setState] = React.useState({
    id: 0,
    vehId: 0,
    imageSource: '',
    vehicle: '',
    shot: '',
    hotSpots: [],
    author: ''
  });

  useEffect(() => {
    const { veh_img_id, veh_id, veh_path_main, parent, name_text } = data;
    setState(prevState => ({
      ...prevState,
      id: veh_img_id,
      vehId: veh_id,
      imageSource: veh_path_main,
      vehicle: parent?.split('|')?.pop(),
      shot: name_text
    }));
  }, [data]);

  const config = {
    autoRotate: 5,
    autoLoad: true,
    loadingLabel: 'Loading interior 360 image',
    showZoomCtrl: false,
    title: state.vehicle,
    hotSpots: state.hotSpots,
    strings: {
      loadingLabel: 'Loading interior 360 Image',
      bylineLabel: 'Shot: %s',
      noPanoramaError: 'No interior 360 image was specified.',
      fileAccessError: 'The interior 360 image could not be accessed.',
      malformedURLError: 'There is something wrong with the interior 360 image URL.',
      iOS8WebGLError: "Due to iOS 8's broken implementation. This interior 360 image uses standard encoding.",
      genericWebGLError:
        'Your browser does not have the necessary support to display this interior 360 image.',
      textureSizeError:
        "This interior 360 image is too big for your device! It's %spx wide, but your device only supports images up to %spx wide.",
      unknownError: 'Error in loading interior 360 image.'
    },
    author: state.shot
  };

  return (
    <CustomModal
      isOpen={isOpen}
      closeClick={toggle}
      modalSize="xl"
      modalTitle="360 Viewer"
      isSaveButtonVisible={false}
    >
      <ErrorBoundary cardtitle="Insta360Viewer">
        <div style={{ position: 'relative', width: '86%', display: 'flex', margin: 'auto' }}>
          <PanoramaViewer
            id={state.shot}
            sceneId={state.shot}
            imageSource={state.imageSource}
            config={config}
          />
          {/* Flag icon */}
          {/* hasActionPermission([ACTION_SLUG_INSTA360_IMAGE_FLAG_MODAL]) && <div style={{ position: "absolute", top: 0, right: 0, zIndex: 100 }}>
            <i
              className={'fa fa-flag fa-2x text-primary clickable mr-2 mt-2'}
              data-nameid={data.name_id}
              data-vidid={data.veh_img_id}
              data-uniqid={data.uniqId}
              onClick={handleFlags} // Assuming handleFlags is defined
            ></i>
          </div> */}
        </div>
      </ErrorBoundary>
    </CustomModal>
  );
};

Insta360ViewerModal.displayName = 'Insta360ViewerModal';
export default memo(Insta360ViewerModal);
